import { render, staticRenderFns } from "./EditBaseInfo.vue?vue&type=template&id=0aab4100&"
import script from "./EditBaseInfo.vue?vue&type=script&lang=js&"
export * from "./EditBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditBaseInfo.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports